import { lazy } from "react";
import { createFileRoute, useParams } from "@tanstack/react-router";

const AdminCaseWorkspace = lazy(() => import("@/pages/admin/AdminCaseWorkspace"));

function CaseRoute() {
  const { ticketId } = useParams({ from: "/admin/arenden/$ticketId" });
  return <AdminCaseWorkspace ticketId={ticketId} />;
}

export const Route = createFileRoute("/admin/arenden/$ticketId")({
  validateSearch: (search: Record<string, unknown>) => ({
    mejl: typeof search["mejl"] === "string" ? (search["mejl"] as string) : undefined,
  }),
  head: () => ({ meta: [{ title: "Ärende – Adminpanel" }] }),
  component: CaseRoute,
});
